import { render, staticRenderFns } from "./db_comparison.vue?vue&type=template&id=3363cdf6&scoped=true&"
import script from "./db_comparison.vue?vue&type=script&lang=js&"
export * from "./db_comparison.vue?vue&type=script&lang=js&"
import style0 from "./db_comparison.vue?vue&type=style&index=0&id=3363cdf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3363cdf6",
  null
  
)

export default component.exports